// @flow
import type {
  AuthState,
  LoginOperation,
} from 'hfty-auth/types'

import type {
  Action,
} from 'fc-flow-types/redux'

// Redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// Selectors, Action Creators, Operator
import { isAuthenticated$, login, removeCredentials } from 'fc-auth'
import { loginOperation$, loginOperator } from 'hfty-auth'
import { username$ } from 'fc-authenticated-user'

// Operator
type Props = {
  username: string,
  isAuthenticated: boolean,
  loginOperation: ?LoginOperation,
}

type Actions = {
  actions: {
    login: typeof login,
  }
}

function onChange (operation: LoginOperation): Action<LoginOperation> {
  const action = loginOperator().actionCreators.updateOperation(operation)

  return {
    ...action,
    error: null,
    meta: null,
  }
}

const mapStateToProps = function<S: { auth: AuthState }> (state: S): Props {
  return {
    username: username$(state),
    isAuthenticated: isAuthenticated$(state),
    loginOperation: loginOperation$(state),
  }
}

const mapDispatchToProps = function (dispatch: Dispatch<*>): Actions {
  return {
    actions: bindActionCreators({
      login,
      logout: removeCredentials,
      onChange,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
